import React from "react";
import { ProtectedRoute } from "@/auth";
import { TaxPremiumGate } from "./TaxPremiumGate";

interface PremiumTaxRouteProps {
  component: React.ComponentType<any>;
  path: string;
  exact?: boolean;
  trigger?: string;
}

/**
 * Like ProtectedRoute but also gates on isPremium.
 * Free users see a full-page paywall instead of the screen.
 */
export const PremiumTaxRoute = ({
  component: Component,
  trigger,
  ...routeProps
}: PremiumTaxRouteProps) => {
  const WrappedComponent = React.useMemo(
    () =>
      function PremiumGated(props: any) {
        return (
          <TaxPremiumGate trigger={trigger}>
            <Component {...props} />
          </TaxPremiumGate>
        );
      },
    [Component, trigger]
  );

  return <ProtectedRoute {...routeProps} component={WrappedComponent} />;
};
